module.exports = __webpack_public_path__ + "static/media/Picture1.a673bcbd.webp";